import Select from "react-select";
import { ParticipantOption } from "../ParticipantsSelectInput";

interface ParticipantsSelectProps {
  participantOptions: ParticipantOption[];
  placeholder: string;
  value: ParticipantOption[];
  onChange: (participantOptions: ParticipantOption[]) => void;
  onBlur?: () => void;
  error: string | undefined;
}

export default function ParticipantsSelect({
  participantOptions,
  placeholder,
  value,
  onChange,
  onBlur,
  error,
}: ParticipantsSelectProps) {
  return (
    <div>
      <Select
        isMulti
        options={participantOptions}
        className="basic-multi-select"
        classNamePrefix="select"
        placeholder={placeholder}
        value={value}
        onChange={(selectedOptions) =>
          onChange(
            (selectedOptions as ParticipantOption[]).filter(
              (option): option is ParticipantOption =>
                option !== null &&
                option !== undefined &&
                option.userOrganizationId !== undefined
            )
          )
        }
        onBlur={onBlur}
        noOptionsMessage={() => "Aucun participant trouvé"}
        styles={{
          control: (baseStyles) => ({
            ...baseStyles,
            backgroundColor: "var(--color-input)",
            borderColor: error ? "red" : "var(--color-border)",
            boxShadow: "none",
            "&:hover": {
              borderColor: "var(--color-border)",
            },
          }),
          option: (styles, { isFocused }) => ({
            ...styles,
            backgroundColor: isFocused ? "var(--color-input)" : undefined,
            color: "inherit",
            "&:hover": {
              backgroundColor: "#383838",
            },
          }),
          menu: (styles) => ({
            ...styles,
            backgroundColor: "var(--color-input)",
          }),
          multiValue: (styles) => ({
            ...styles,
            backgroundColor: "var(--color-selected)",
          }),
          multiValueLabel: (styles) => ({
            ...styles,
            fontWeight: "bold",
            color: "var(--color-primary)",
          }),
          multiValueRemove: (styles) => ({
            ...styles,
            cursor: "pointer",
            color: "var(--color-primary)",
            "&:hover": {
              backgroundColor: "var(--color-selected)",
              color: "var(--color-primary)",
            },
          }),
          input: (styles) => ({
            ...styles,
            color: "white",
          }),
          placeholder: (styles) => ({
            ...styles,
            color: "var(--color-secondary)",
          }),
          indicatorSeparator: (styles) => ({
            ...styles,
            display: "none",
          }),
        }}
      />
      {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
    </div>
  );
}
